
export const SFE_STEP_INFO = [
  [//我的单据
    { step: 0, name: 'MyDoc', stauts: -1, activeBtn: 'Common.Canceled' },
    { step: 0, name: 'MyDoc', stauts: 0, activeBtn: 'Common.OnGoing' },
    { step: 0, name: 'MyDoc', stauts: 1, activeBtn: 'Common.ApprovalCompleted' },
    { step: 0, name: 'MyDoc', stauts: 2, activeBtn: 'Common.Rejected' },
  ],
  [//申请单位签核--项目管理签核
    { step: 1, name: 'ApplyingUnit', stauts: 0, activeBtn: 'Common.ToBeApproved' },
    { step: 1, name: 'ApplyingUnit', stauts: 1, activeBtn: 'Common.Approved' },
  ],
  [//申请单位签核--部级签核
    { step: 2, name: 'ApplyingUnit', stauts: 0, activeBtn: 'Common.ToBeApproved' },
    { step: 2, name: 'ApplyingUnit', stauts: 1, activeBtn: 'Common.Approved' },
  ],
  [//厂务签核--课级签核--任务指派
    { step: 3, name: 'FacilityApproval', stauts: 0, activeBtn: 'Common.ToBeApproved' },
    { step: 3, name: 'FacilityApproval', stauts: 1, activeBtn: 'Common.Approved' },
  ],
  [//预约厂商&概算--预约厂商
    { step: 4, name: 'VendorAppointment', stauts: 0, activeBtn: 'Common.AppointmentPending' },
    { step: 4, name: 'VendorAppointment', stauts: 1, activeBtn: 'Common.AppointmentCompleted' },
  ],
  [//厂商标单制定
    { step: 5, name: 'BidCreating', stauts: -2, activeBtn: 'Common.Rejected' },
    { step: 5, name: 'BidCreating', stauts: 0, activeBtn: 'Common.ToBeCreated' },
    { step: 5, name: 'BidCreating', stauts: 1, activeBtn: 'Common.Created' },
  ],
  [//预约厂商&概算--厂务概算制定
    { step: 6, name: 'VendorAppointment', stauts: 0, activeBtn: 'Common.ToBeCreated' },
    { step: 6, name: 'VendorAppointment', stauts: 1, activeBtn: 'Common.Created' },
    { step: 6, name: 'VendorAppointment', stauts: 2, activeBtn: 'Common.Rejected' },
  ],
  [//厂务签核--厂务课级--标单审核/概算审核
    { step: 7, name: 'FacilityApproval', stauts: 0, activeBtn: 'Common.ToBeApproved' },
    { step: 7, name: 'FacilityApproval', stauts: 1, activeBtn: 'Common.Approved' },
  ],
  [//厂务签核--厂务部级--标单审核/概算审核
    { step: 8, name: 'FacilityApproval', stauts: 0, activeBtn: 'Common.ToBeApproved' },
    { step: 8, name: 'FacilityApproval', stauts: 1, activeBtn: 'Common.Approved' },
  ],
  [//一般工程:申请单位签核--概算签核; 专案工程:厂务助理询价--询价
    { step: 9, name: 'ApplyingUnit', stauts: 0, activeBtn: 'Common.ToBeApproved', projectCategory: 0 },
    { step: 9, name: 'ApplyingUnit', stauts: 1, activeBtn: 'Common.Approved', projectCategory: 0 },
    { step: 9, name: 'FacAssInquiry', stauts: 0, activeBtn: 'Common.INQUIRY', projectCategory: 1 },
    { step: 9, name: 'FacAssInquiry', stauts: -1, activeBtn: 'Common.Canceled', projectCategory: 1 },
  ],
  [//一般工程:厂务助理询价--询价; 专案工程:申请单位签核--概算签核
    { step: 10, name: 'FacAssInquiry', stauts: 0, activeBtn: 'Common.INQUIRY', projectCategory: 0 },
    { step: 10, name: 'FacAssInquiry', stauts: -1, activeBtn: 'Common.Canceled', projectCategory: 0 },
    { step: 10, name: 'ApplyingUnit', stauts: 0, activeBtn: 'Common.ToBeApproved', projectCategory: 1 },
    { step: 10, name: 'ApplyingUnit', stauts: 1, activeBtn: 'Common.Approved', projectCategory: 1 },
  ],
  [// 厂务助理询价--待开PR
    { step: 11, name: 'FacAssInquiry', stauts: 0, activeBtn: 'Common.PRPending' },
    { step: 11, name: 'FacAssInquiry', stauts: -1, activeBtn: 'Common.Canceled' },
  ],
  [// 厂务助理询价--PR签核中
    { step: 12, name: 'FacAssInquiry', stauts: 0, activeBtn: 'Common.PRApproving' },
    { step: 12, name: 'FacAssInquiry', stauts: -1, activeBtn: 'Common.Canceled' },
  ],
  [// 厂务助理询价--下PO
    { step: 13, name: 'FacAssInquiry', stauts: 0, activeBtn: 'Common.PORequest' },
    { step: 13, name: 'FacAssInquiry', stauts: -1, activeBtn: 'Common.Canceled' },
  ],
]